export default __webpack_public_path__ + "static/media/view.94295d99.svg";